import {pxToRem} from '../../utills/pxToRem'
import Fonts from '../../static/fonts/fonts'
import {fonts} from '../../theme/foundations/fonts'

export const brandLogo = {
    height: [pxToRem(41), pxToRem(41), pxToRem(53), pxToRem(53)]
}

export const loyaltyHeader = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(18), pxToRem(18), [pxToRem(22), pxToRem(22)]],
    letterSpacing: pxToRem(3),
    lineHeight: 'normal',
    marginTop: [
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(20)} !important`,
        `${pxToRem(20)} !important`
    ],
    marginBottom: [
        `0 !important`,
        `0 !important`,
        `${pxToRem(5)} !important`,
        `${pxToRem(5)} !important`
    ]
}

export const topHeader = {
    color: 'black',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    marginTop: [`${pxToRem(20)} !important`]
}

export const apiErrorMessage = {
    color: 'black',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    lineHeight: 'normal',
    margin: 0,
    paddingLeft: pxToRem(10)
}

export const nameWrapper = {
    flexDirection: 'row',
    columnGap: pxToRem(10),
    flexWrap: ['wrap', 'wrap', 'nowrap', 'nowrap']
}

export const formControlStyle = {
    marginTop: '0 !important'
}

export const formLabelStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [
        `${pxToRem(16)} !important`,
        `${pxToRem(16)} !important`,
        `${pxToRem(16)} !important`,
        `${pxToRem(16)} !important`
    ],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [`${pxToRem(1)} !important`],
    marginTop: [
        `${pxToRem(15)} !important`,
        `${pxToRem(15)} !important`,
        `${pxToRem(20)} !important`,
        `${pxToRem(20)} !important`
    ],
    marginRight: 0,
    height: pxToRem(20)
}

export const giftCardLabelStyle = {
    ...formLabelStyle,
    marginTop: [
        `${pxToRem(11.2)} !important`,
        `${pxToRem(11.2)} !important`,
        `${pxToRem(8)} !important`,
        `${pxToRem(8)} !important`
    ]
}

export const formLabelStarStyle = {
    ...formLabelStyle,
    display: 'inline',
    color: 'cav_red',
    marginTop: 0
}

export const formErrorMessageStyle = {
    ...formLabelStyle,
    color: 'cav_red',
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    marginTop: pxToRem(8),
    marginBottom: 0,
    fontStyle: 'italic'
}

export const formInputStyle = {
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    color: 'black',
    borderColor: 'black',
    borderRadius: 0,
    fontFamily: fonts.primary,
    fontSize: [pxToRem(16), pxToRem(16), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)]
}

export const formInputErrorStyle = {
    height: pxToRem(40),
    color: 'black',
    borderColor: 'cav_error_red',
    backgroundColor: 'cav_error_bg_red',
    borderRadius: 0,
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)]
}

export const mobilePrependText = {
    color: 'cav_dark_gray_rbg',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)],
    margin: 0
}

export const passwordReqGroup = {
    margin: '0 !important',
    paddingLeft: pxToRem(10)
}

export const passwordReqItem = {
    margin: 0,
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)]
}

export const createAccountButton = {
    width: ['100%', '100%', pxToRem(421), pxToRem(421)],
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    color: 'white',
    backgroundColor: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14)],
    fontWeight: 700,
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    borderRadius: 0,
    margin: `0 !important`,
    '&:hover': {
        color: 'cav_red',
        backgroundColor: 'white'
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    }
}

export const termsPrivacyInfo = {
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    marginTop: [
        `${pxToRem(25)} !important`,
        `${pxToRem(25)} !important`,
        `${pxToRem(12)} !important`,
        `${pxToRem(12)} !important`
    ],
    marginBottom: `${pxToRem(20)} !important`
}

export const termsPrivacyInfoLink = {
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1)],
    textDecoration: 'underline'
}

export const styleAccountBenefits = {
    '.benefits': {
        display: 'flex',
        columnGap: pxToRem(10),
        marginTop: [pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(20)],
        marginBottom: [pxToRem(5), pxToRem(5), pxToRem(20), pxToRem(20)],
        div: {
            flex: '1',
            img: {
                height: [pxToRem(43), pxToRem(43), pxToRem(59), pxToRem(59)],
                margin: '0 auto',
                marginBottom: pxToRem(10)
            },
            p: {
                color: 'black',
                fontFamily: fonts.primary,
                textAlign: 'center',
                fontSize: [pxToRem(9), pxToRem(9), pxToRem(13), pxToRem(13)],
                fontWeight: '400',
                lineHeight: 'normal',
                letterSpacing: pxToRem(1),
                margin: 0
            }
        }
    }
}
